module.exports = __webpack_public_path__ + "img/pick-up.299bb817.png";